import { FiEdit2, FiTrash2, FiCheckCircle, FiXCircle } from "react-icons/fi";
import { Table, Button } from "reactstrap";
import NotFoundDataUI from "../cards/NotFoundDataUI";

const AllowedManufacturersTable = ({
    data,
    handleDelete,
    onEdit,
    manufacturersMap
}) => {
    return (
        <div>
            <Table
                responsive
                hover
                bordered
                className="mb-0"
                style={{
                    fontSize: "13px",
                    overflow: "hidden",
                    border: "1px solid #e2e8f0"
                }}
            >
                <thead>
                    <tr style={{ backgroundColor: "#00509d", color: "white" }}>
                        <th className="text-center" style={{ borderBottom: "none" }}>#</th>
                        <th className="text-center" style={{ borderBottom: "none" }}>DNH Vendor Name</th>
                        <th className="text-center" style={{ borderBottom: "none" }}>Local Manufacturer</th>
                        <th className="text-center" style={{ borderBottom: "none" }}>Markup %</th>
                        <th className="text-center" style={{ borderBottom: "none" }}>Enabled</th>
                        <th className="text-center" style={{ borderBottom: "none" }}>Sync to Algolia</th>
                        <th className="text-center" style={{ borderBottom: "none" }}>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {data?.length > 0 ? (
                        data.map((item, index) => (
                            <tr
                                key={index}
                                className="align-middle"
                                style={{
                                    backgroundColor: index % 2 === 0 ? "#ffffff" : "#f8fafc",
                                    borderBottom: "1px solid #f1f5f9"
                                }}
                            >
                                <td className="text-center text-muted">{index + 1}</td>
                                <td className="text-center fw-bold">{item?.dnhVendorName}</td>
                                <td className="text-center">
                                    <span className="user-badge bg-primary-soft">
                                        {manufacturersMap[item?.manufacturerId] || item?.manufacturerId}
                                    </span>
                                </td>
                                <td className="text-center fw-bold text-primary">
                                    {((item?.markupPercent || 0) * 100).toFixed(2)}%
                                </td>
                                <td className="text-center">
                                    {item?.enabled ? (
                                        <span className="user-badge bg-success-soft text-success d-inline-flex align-items-center gap-1">
                                            <FiCheckCircle size={12} /> Enabled
                                        </span>
                                    ) : (
                                        <span className="user-badge bg-danger-soft text-danger d-inline-flex align-items-center gap-1">
                                            <FiXCircle size={12} /> Disabled
                                        </span>
                                    )}
                                </td>
                                <td className="text-center">
                                    {item?.syncToAlgolia ? (
                                        <span className="user-badge bg-primary-soft d-inline-flex align-items-center gap-1">
                                            <FiCheckCircle size={12} /> Yes
                                        </span>
                                    ) : (
                                        <span className="user-badge bg-secondary-soft d-inline-flex align-items-center gap-1">
                                            <FiXCircle size={12} /> No
                                        </span>
                                    )}
                                </td>
                                <td className="text-center">
                                    <div className="d-flex align-items-center justify-content-center gap-2">
                                        <Button
                                            color="link"
                                            className="p-1 border-0"
                                            onClick={() => onEdit(item)}
                                            title="Edit"
                                        >
                                            <FiEdit2 className="text-primary" size={14} />
                                        </Button>
                                        <Button
                                            color="link"
                                            className="p-1 border-0"
                                            onClick={() => handleDelete(item?._id)}
                                            title="Delete"
                                        >
                                            <FiTrash2 className="text-danger" size={16} />
                                        </Button>
                                    </div>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="7">
                                <NotFoundDataUI message="No allowed manufacturers found" />
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </div>
    );
};

export default AllowedManufacturersTable;
